import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDuplicateFormTemplateMutation } from '../../../../hooks/mutations/useFormTemplateMutation';
import { useFormTypesQuery } from '../../../../hooks/queries/useFormTypesQuery';
import { capitalizeFirstLetter } from '../../../../utils/capitalize';
import CustomTextInput from '../../../ui/CustomTextInput';
import { OptionType } from '../../../ui/DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';

interface DuplicateFormModalProps extends ModalProps {
    refetch?: () => void;
    initialFormId: string;
    initialTitle: string;
}

const DuplicateFormModal: React.FC<DuplicateFormModalProps> = ({ open, handleClose, refetch = () => {}, initialFormId, initialTitle }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [formTitle, setFormTitle] = useState(`${capitalizeFirstLetter(t('copyOf'))} ${initialTitle}`);

    const { mutate: duplicateFormTemplate } = useDuplicateFormTemplateMutation({
        onSuccess: (data) => {
            navigate(`/qhse/forms/${data.data._id}`);
            refetch();
        },
    });

    return (
        <ModalBody
            title={t('form')}
            subtitle={t('createCopy')}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                duplicateFormTemplate({ templateId: initialFormId, title: formTitle });
            }}
            disableSubmit={!formTitle.length}
        >
            <CustomTextInput value={formTitle} onChange={(text) => setFormTitle(text)} label={t('title')} required />
        </ModalBody>
    );
};

export default DuplicateFormModal;
